/*
 * Copyright (C) 2020 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {useState, useEffect, useCallback} from 'react'
import {useDebouncedCallback} from 'use-debounce'

const useSearch = (debounceTime = 500) => {
  const [search, setSearch] = useState('')
  const [debouncedSearch, setDebouncedSearch] = useState('')

  const debouncedCallback = useDebouncedCallback(value => {
    setDebouncedSearch(value)
  }, debounceTime)

  const onChangeHandler = useCallback(event => setSearch(event.target.value), [])
  const onClearHandler = useCallback(() => {
    setSearch('')
    setDebouncedSearch('')
  }, [])

  useEffect(() => {
    debouncedCallback(search)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  return {
    search,
    debouncedSearch,
    onChangeHandler,
    onClearHandler,
  }
}

export default useSearch
